export default __webpack_public_path__ + "static/media/item-premium.4b664932.png";